import { Edge } from "@antv/x6"
import { useGraphInstance } from "@antv/xflow"
import { useState, useCallback, useEffect, useRef } from "react"
import { throttleTime, tap, switchMap, takeUntil } from "rxjs"
import { createCanvasEvent$ } from "../../events/helper"
import { createBasicLine } from "../../nodes"
import { v4 as uuidv4 } from "uuid";

interface DrawingLineProps {

}

export function DrawingLine(props: DrawingLineProps) {
  const graph = useGraphInstance()
  const [key, setKey] = useState(uuidv4());
  let lineRef = useRef<Edge | null>(null)

  const reset = useCallback(() => {
    lineRef.current = null
    setKey(uuidv4())
  }, []);
  
  useEffect(() => {
    if (!graph) return;
    const points: PositionLike[] = []
    const mouseDown$ = createCanvasEvent$(graph, 'mousedown')
    const mouseMove$ = createCanvasEvent$(graph, 'mousemove').pipe(throttleTime(20))
    const end$ = createCanvasEvent$(graph, 'dblclick')

    const normalDrawingStart$ = mouseDown$.pipe(
      tap((evt: any) => {
        const pageX = evt.clientX;
        const pageY = evt.clientY;

        const point = graph.clientToLocal(pageX, pageY);
        
        points.push(point)
      }),
      takeUntil(end$)
    )

    const sub = normalDrawingStart$.pipe(
        switchMap(() => {
          return mouseMove$
        }),
        takeUntil(end$)
      )
      .subscribe({
        next: (evt: any) => {
          const pageX = evt.clientX;
          const pageY = evt.clientY;

          const movePoint = graph!.clientToLocal(pageX, pageY);
          const line = lineRef.current;
          if (!line) {
            const newLine = graph!.createEdge(createBasicLine(points[0], movePoint))
            lineRef.current = newLine
            newLine.setAttrByPath('path/pointerEvents', 'none')
            const lineData = newLine.getData()
            newLine.setData({...lineData, drawing: true})
            graph!.addEdge(newLine)
          } else {
            const source = line.getSource() as any
            if (source.cell && source.port) {
              line!.setVertices(points)
              line!.setTarget(movePoint)
            } else {
              const [start, ...others] = points
              line!.setSource(start)
              line!.setTarget(movePoint)
              line!.setVertices(others)
            }
          }
        },
        complete: () => {

          const offset = -2
          const line = lineRef.current;
          if (line) {
            line.setSource(points[0])
            line.setTarget(points[points.length + offset])
            line.setVertices(points.slice(1, offset))
            const lineData = line!.getData()
            delete lineData.drawing
            line.setData({...lineData})
            line.removeAttrByPath('path/pointerEvents')
          }
          reset()
        }
      })


    return () => {
      sub.unsubscribe()
      lineRef.current = null
    }
  }, [graph, reset, key])
  return null
}